import { Component, inject } from '@angular/core';
import { ClawService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ClawCreateDto,
  ClawDto,
  ClawExcelDownloadDto,
  ClawUpdateDto,
} from '../proxy/general/dtos/claw';
import { CLAW_CONFIG, CLAW_FIELDS } from './claw.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-claw',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ClawService, ConfirmationService],
  templateUrl: './claw.html',
  styleUrl: './claw.scss',
})
export class Claw extends BaseCrudComponent<
  ClawDto,
  ClawCreateDto,
  ClawUpdateDto,
  ClawExcelDownloadDto
> {
  service = inject(ClawService);
  config = CLAW_CONFIG;
  fields = CLAW_FIELDS;

  protected prepareUpdateDto(data: any, selected: ClawDto): ClawUpdateDto {
    return {
      size: data.size,
      brandId: data.brandId,
      modelId: data.modelId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Claw';
  }
}
